<style lang="less">
.smscode{
	.code{
		display: -webkit-box; display:flex;
		-webkit-box-align: center; align-items: center;
		input{
			width: auto;
			-webkit-box-flex: 1; -moz-box-flex: 1; -ms-flex: 1; flex: 1;
			text-align: right;
		}
		span{
			display: inline-block;
			width: 90px;
			text-align: center;
			color: #dc2a2a;
			font-size: 14px;
			white-space:nowrap;
			font-weight: 600;
			align-items: center;
			justify-content: space-between;
			&.inactive{
				color: #ddd;
			}
		}
		.separator{
			width: 1px;
			height: 16px;
			background: #ccc;
			margin: 0 7px 0 10px;
		}
	}
}
</style>

<template>
	<!-- Main smscode -->
	<div class="item smscode">
		<div class="label">验证码</div>
		<div class="cont code">
			<input type="tel" value="" placeholder="请输入验证码" v-model="smscode" maxlength="6" />
			<div class="separator">&nbsp;</div>
			<span v-if="isActive" @click="send">{{ second > 1 ? '获取验证码' : '重发验证码' }}</span>
			<span class="inactive" v-else>{{second}}秒后重发</span>
		</div>
	</div>
</template>

<script>
	export default {
		data: function () {
			return {
				isActive: true,
				second: 60,
				smscode: '',
				timer: null,
			};
		},
		components: {
		},
		props: {
			code: {
				type: String,
				default: ''
			},
			initSecond: {
				type: String,
				default: ''
			},
			start: {
				default: ''
			}
		},
		mounted: function () {
		},
		methods: {
			send: function () {
				this.counter();
				this.isActive = false;
				this.$emit('send');
			},
			counter: function () {
				if (this.second > 1) {
					this.second --;
					let _this = this;
					this.timer = setTimeout(function () {
						_this.counter();
					}, 1000);
				} else {
					clearTimeout(this.timer);
					this.second = 60;
					this.isActive = true;
				}
			}
		},
		watch: {
			code: function (n) {
				this.smscode = n;
			},
			smscode: function (n) {
				this.$emit('smscode', n);
			},
			initSecond: function () {
				console.log('initSecondTimes',this.initSecond);
				clearTimeout(this.timer);
				this.second = 60;
				this.isActive = true;
			},
			start: function (n) {
				console.log('timestart', n);
				this.send();
			}
		}
	};
</script>


// WEBPACK FOOTER //
// src/components/smscode.vue